import { useMemo } from 'react';

import ChartDateFormatter from '../../ChartDateFormatter';
import Tooltip from '../Tooltip/index';

export const useTooltipElementsMemo = ({
  metricsTooltip,
  data,
  percentage,
  compareMode,
  getCategoryPeriod,
}) => {
  return useMemo(() => {
    if (metricsTooltip) {
      const {
        labelTemplate,
        compareDisabled = false,
        posStrategy,
      } = metricsTooltip;
      return (
        <Tooltip
          data={data}
          percentage={percentage}
          posStrategy={posStrategy}
          labelFormatter={({ value }) => {
            const [base, compared] = getCategoryPeriod(value);
            return (
              <ChartDateFormatter
                base={base}
                compared={compared}
                template={labelTemplate}
                compareMode={compareDisabled ? false : compareMode}
              />
            );
          }}
        />
      );
    }
  }, [data, percentage, compareMode, metricsTooltip]);
};
